module.exports = __webpack_public_path__ + "static/media/SR_featureWalkthrough_v06_1x1_01.09e2b08f.mp4";